<template>
    <data-grid ref="list"
               class="grid-static-text"
               :settings="grid"
               :page="parseInt($route.params.page)"
               storeDispatchList="translate/list"
               v-on:changePage="$router.push({name: $route.name, params: {page: $event}})"
    >
        <template slot="translate" slot-scope="data">
            <static-text-input :translate-id="data.item.id"
                               :locales="data.item.translateLocale"
                               :type="data.item.type"
                               v-if="data.item.html === false"
            />

            <button type="button"
                    class="btn btn-sm btn-translate btn-outline-secondary"
                    v-if="data.item.html === true"
                    @click="$refs['translateModal' + data.item.id].show()"
            >
                {{t('Translate')}}
            </button>

            <b-modal :ref="'translateModal' + data.item.id" :title="data.item.slug" size="lg" hide-footer>
                <static-text-redactor :translate-id="data.item.id"
                                      :locales="data.item.translateLocale"
                                      :type="data.item.type"
                />
            </b-modal>

        </template>
        <template slot="slug" slot-scope="data">
            <div>{{data.item.slug}}</div>
            <span class="badge"
                  :class="{'badge-primary': data.item.html === true, 'badge-light': data.item.html === false}"
                  @click="toggleHtml(data.item.id)"
            >
                {{data.item.html === false ? t('Set as html') : t('HTML')}}
            </span>
            <span class="badge badge-light c-pointer" v-b-tooltip.hover.top
                  :title="t('Type')">{{data.item.type}}</span>
        </template>
    </data-grid>
</template>

<script>
    import DataGrid from '../../../core/DataGrid/DataGrid'
    import StaticTextInput from "./StaticTextInput";
    import StaticTextRedactor from '../../Pages/StaticText/StaticTextRedactor';

    export default {
        components: {
            StaticTextRedactor,
            StaticTextInput,
            DataGrid
        },
        methods: {
            toggleHtml(id) {
                this.$store.dispatch('translate/toggleHtml', id).then(res => {
                    this.$refs.list.fetchData();
                }).catch(error => {
                    this.$refs.list.fetchData();
                });
            },
            loadTranslates() {
                this.i18n.pushStrings().then(response => {
                    this.$refs.list.fetchData();
                    this.i18n.removeStoredStrings();
                }, error => {
                    console.log('error');
                });
            }
        },
        data() {
            return {
                selectedDataId: null,
                grid: {
                    columns: [
                        {
                            type: 'string',
                            name: this.t('Identificator'),
                            key: 'slug',
                            filter: {
                                type: 'fulltext',
                                likeType: '%_like_',
                            },
                        }, {
                            type: 'string',
                            name: this.t('Translate'),
                            key: 'translate',
                            filter: {
                                field: 'translateLocale->value',
                                type: 'fulltext',
                                likeType: '%_like_',
                            },
                        },
                    ]
                },
            }
        }
    }
</script>
<style lang="scss">
    .c-pointer {
        cursor: pointer;
    }

    .btn-translate {
        border: 1px solid #ced4da;
        margin-top: -8px;
    }

    .grid-static-text {
        .titan-grid-column-translate .td-content {
            padding-top: 0.5rem;
            padding-bottom: 0;
            border-left-width: 0.5rem;
            border-right-width: 0.5rem;
        }
    }
</style>



// WEBPACK FOOTER //
// src/admin/Pages/StaticText/StaticText.vue